export const sanitizeString = (value: string): string => {
  return value.replace(/\D/g, '');
};

export const cpfFormat = (cpf: string) => {
  cpf = cpf.replace(/\D/g, '');

  if (cpf.length <= 11) {
    cpf = cpf.replace(/(\d{3})(\d)/, '$1.$2');
    cpf = cpf.replace(/(\d{3})(\d)/, '$1.$2');
    cpf = cpf.replace(/(\d{3})(\d{1,2})$/, '$1-$2');
  } else {
    cpf = cpf.replace(/^(\d{2})(\d)/, '$1.$2');
    cpf = cpf.replace(/^(\d{2})\.(\d{3})(\d)/, '$1.$2.$3');
    cpf = cpf.replace(/\.(\d{3})(\d)/, '.$1/$2');
    cpf = cpf.replace(/(\d{4})(\d)/, '$1-$2');
  }

  return cpf;
};

export const cepFormat = (postal: string) => {
  postal = postal.replace(/\D/g, '');
  if (postal.length > 8) {
    postal = postal.slice(0, -1);
  }
  postal = postal.replace(/^([0-9]{5})([0-9]{3})$/, '$1-$2');

  return postal.toString();
};

export const emailValidation = (email: String) => {
  let usuario = email.substring(0, email.indexOf('@'));
  let dominio = email.substring(email.indexOf('@') + 1, email.length);

  if (
    usuario.length >= 1 &&
    dominio.length >= 3 &&
    usuario.search('@') === -1 &&
    dominio.search('@') === -1 &&
    usuario.search(' ') === -1 &&
    dominio.search(' ') === -1 &&
    dominio.search('.') !== -1 &&
    dominio.indexOf('.') >= 1 &&
    dominio.lastIndexOf('.') < dominio.length - 1
  ) {
    return true;
  } else {
    return false;
  }
};

export const normalize = (str: string) => {
  const parse = str
    .normalize('NFD')
    .replace(/([\u0300-\u036f]|[^0-9a-zA-Z])/g, '');
  return parse;
};

export const phoneFormat = (value: string) => {
  let phone = value.replace(/\D/g, '').replace(/^0/, '');

  if (phone.length <= 10) {
    phone = phone.replace(/(\d{2})(\d)/, '($1) $2');
    phone = phone.replace(/(\d{4})(\d)/, '$1-$2');
    phone = phone.replace(/(\d{4})(\d)$/, '$1');
  } else {
    phone = phone.replace(/(\d{2})(\d)/, '($1) $2');
    phone = phone.replace(/(\d{5})(\d)/, '$1-$2');
    phone = phone.replace(/(\d{4})(\d)$/, '$1');
  }
  return phone;
};

export const cnpjFormat = (cnpj: string) => {
  cnpj = cnpj.replace(/\D/g, '');

  if (cnpj.length > 14) cnpj = cnpj.slice(0, -1);

  cnpj = cnpj.replace(/(\d{2})(\d)/, '$1.$2');
  cnpj = cnpj.replace(/(\d{3})(\d)/, '$1.$2');
  cnpj = cnpj.replace(/(\d{3})(\d)/, '$1/$2');
  cnpj = cnpj.replace(/(\d{4})(\d)/, '$1-$2');

  return cnpj;
};

export const bornDateFormat = (value: string) => {
  let bornDate = value.replace(/\D/g, '');

  bornDate = bornDate.replace(/(\d{2})(\d)/, '$1/$2');
  bornDate = bornDate.replace(/(\d{2})(\d)/, '$1/$2');
  bornDate = bornDate.replace(/(\d{4})(\d)/, '$1/$2');

  return bornDate;
};

export const normalizeBornDate = (value: string) => {
  let bornDate = value;

  bornDate = bornDate.replace(/(\d{2})(\d)/, '$1/$2');
  bornDate = bornDate.replace(/(\d{2})(\d)/, '$1/$2');
  bornDate = bornDate.replace(/(\d{4})(\d)/, '$1/$2');

  bornDate = bornDate.split('/').reverse().join('-');

  return bornDate;
};

export const formatBankAgency = (value: string) => {
  return value
    .replace(/\D/g, "")
    .replace(/(\d{5})(\d)/, "$1");
};

export const normalizeBankAccount = (value: string) => {
  // return value.replace( /(\d+)-(\d)/, '$1-$2');
  return value.replace(/(\d{4,8})(\d{1})/, '$1-$2')
}

export const formatBankAccount = (value: string) => {
  return value
    .replace(/\D/g, "")
    .replace(/(\d{13})(\d)/, "$1");
}

export const ensureCurrency = (value: string) => {
  const newValue = value
    .replace('.', ',')
    .replace(/^/, 'R$ ')
    .replace(/(\d)(?=(\d{3})+,)/g, '$1.');

  const decimalIndex = newValue.indexOf(',');
  if (decimalIndex !== -1) {
    return newValue.slice(0, decimalIndex + 3);
  } else {
    return `${newValue},00`;
  }
}

export const parseCurrencyInCents = (value: string): string => {
  const number = parseInt(value);

  return new Intl.NumberFormat('pt-BR', {
    style: 'currency',
    currency: 'BRL',
  }).format(number / 100);
}